<template>
    <div >
      <MdTitle v-bind:Text="$t('PatientAlerts.PatientAlerts')" />
      <div class="row">
          <div class="col-sm-12 col-md-12 mb-4">
            <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                <div class="input-group">
                      <input 
                        type="text" 
                        class="form-control"
                        v-model="parameter.SearchCriteria"   
                          @keyup.enter="LoadAlerts"                            
                      >
                      <div class="input-group-append">
                          <div class="input-group-append">
                          <MdButton 
                            v-bind:Name="'btnsearchinput'"
                            v-bind:VariantProp="'btn btn-sm search-attached'"
                            v-bind:IconClass="'mdi mdi-magnify'"
                            v-on:click="LoadAlerts">
                          </MdButton>
                      </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      <b-row>
          <b-col lg="3" md="3" sm="12">
            <MdEdit 
              v-bind:Label="$t('Shared.datefrom')"
              v-bind:TypeProp="'date'" 
              v-bind:Name="'datefrom'"
              v-bind:Min="'1900-01-01'"
              v-bind:Max="'2200-12-31'"
              v-model="dateFrom"
              v-bind:isRequired="true">                                     
            </MdEdit>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdEdit 
              v-bind:Label="$t('Shared.dateTo')"
              v-bind:TypeProp="'date'" 
              v-bind:Name="'dateto'"
              v-bind:Min="'1900-01-01'"
              v-bind:Max="'2200-12-31'"
              v-model="dateTo"
              v-bind:isRequired="true">                                     
            </MdEdit>
          </b-col>
          <b-col lg="3" md="3" sm="12">         
            <MdSelect
              v-bind:Label="$tc('Shared.Patient',2)"
              v-bind:Options="PatientsList"
              v-bind:Model="PatientCodeModel"
              v-bind:FieldDescription="'patientName'"
              v-bind:FieldCode="'patientcode'"
              v-bind:Multiple="true"             
              :Input="ChangeDropDownPatients"
              :CustomLabel="customLabelPatients"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
                v-bind:Label="$t('PatientAlerts.AlertStatus')"
                v-bind:Options="showOptions"
                v-bind:Model="showAlertStatusModel"
                v-bind:FieldDescription="'text'"
                v-bind:FieldCode="'value'" 
                v-bind:Multiple="false"                      
                :Input="ChangeIsActiveAlert"
                v-bind:AllowEmpty="false"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
                v-bind:Label="$tc('Allergy.PatientStatus')"
                v-bind:Options="showOptions"
                v-bind:Model="showPatientIsActiveModel"
                v-bind:FieldDescription="'text'"
                v-bind:FieldCode="'value'" 
                v-bind:Multiple="false"                      
                :Input="ChangeIsActive"
                v-bind:AllowEmpty="false"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$tc('Allergy.AdmissionStatus')"
              v-bind:Options="showOptions"
              v-bind:Model="showIsActiveAdmissionModel"
              v-bind:FieldDescription="'text'"
              v-bind:FieldCode="'value'" 
              v-bind:Multiple="false"                      
              :Input="ChangeIsActiveAdmission"
              v-bind:AllowEmpty="false"/>
          </b-col>
          <b-col lg="3" md="3" sm="12"/>
          <b-col lg="3" md="3" sm="12">
            <div class="text-md-right mt-3">
                <button 
                    v-on:click="LoadAlerts"
                    type="button"
                    class="btn btn-primary btn-login mx-2"												
                    id="btnsearchinput">
                    {{ $t('Shared.Search') }}
                </button>
            </div>
          </b-col>   
     
        </b-row>
         <div class="row">
          <div class="col-12 mt-2">
           
                <MdTitle  v-bind:Text="$t('Shared.SearchResult')" 
                          v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
              <div class="row">
                <div class="col-md-12">
                  <MdTable 
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:refTable="refTable"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction"
                    v-bind:FieldsDate="FieldsDateArr">
                  </MdTable>
                </div>
            </div>
          </div>
        </div>
        <div class="space-actions"></div>
        <div class="page-actions">
          <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="reportList"
            v-bind:Name="'btn_ReportList'"/>
          <MdButton
            v-bind:Label="$t('Shared.Report')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="onClickShowReport"
            v-bind:Name="'btn_Print'"/>
            
         <b-dropdown id="dropdown-dropup" dropup :text="$t('Shared.Export')" variant="primary" class="m-2">
						<b-dropdown-item v-on:click="handlePdf('export')">{{$t('Shared.PDF')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handlePdf('email')">{{$t('Shared.PDFByEmail')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('export')">{{$t('Shared.CSV')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('email')">{{$t('Shared.CSVByEmail')}}</b-dropdown-item>
					</b-dropdown>   

        </div>

      
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="$t('PatientAlerts.PatientAlerts')"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="reportPatientAlertFilters"
          :ReportName="'PatientAlertFilters'"
          :ReportTitle="$t('PatientAlerts.PatientAlerts')"
          :IsAnAPIReport="true"
        />
    </DxPopup>
    <CSVExportHelper
      ref="csvExportHelper"
      v-bind:conformSubject="$t('PatientAlerts.PatientAlerts')"
      v-bind:sendEmailAPI="'/Activities/email'"
      v-bind:exportCsvAPI="'/Activities/exportCSV'"
    >    
    </CSVExportHelper>
    </div>
</template>

<script>
  import Vue from 'vue'
  import { DxPopup } from 'devextreme-vue/popup';
  import PatientService from '@/services/patient.service'
  import ShowMessage from '@/components/messages/ShowMessage.js'
  import DBFunctions from '@/common/DBFunctions.js'
  import ActivitiesService from '@/services/activities.service'
  import Utils from '../../../common/utils'
  import { EventBus } from '@/event-bus.js';

  export default Vue.extend({
      name: "patientAlertFiltersRep",
      mixins: [ ShowMessage, DBFunctions ],
      components: { DxPopup },
      data() {
          return {
              isParamVisible: true,
              isReportVisible: false,
              dateFrom: null,
              dateTo: null,
              reportParams: [],
              PatientsList:[],
              PatientCodeModel:'',
              showOptions: [
                { value: "all", text: this.$t('Shared.All') },
                { value: "true", text:this.$t('Shared.Active') },
                { value: "false", text: this.$t('Shared.Inactive') },
              ],
              showPatientIsActiveModel: {
                "value":"true",
                "text":this.$t('Shared.Active')
              },
              showIsActiveAdmissionModel: {
                "value":"true",
                "text":this.$t('Shared.Active')
              },
              showAlertStatusModel: {
                "value":"true",
                "text":this.$t('Shared.Active')
              },           
              parameter:{
                SearchCriteria:'',
                PageNumber : 0,
                PageSize:0,
                Status: true,       
              },
              params: {
                "PatientCodeList": [],
                "IsActiveAlert": true,
                "IsActive": true,
                "IsActiveAdmission": true
              },
            
              items: [],         
              fields: [
                { key: 'datechanged', sortable: true, label: this.$t('ActList.DateChanged'), class: 'text-rigth' },
                { key: 'userName', sortable: true, label: this.$tc('ActList.Employee'), class: 'text-rigth' },       
                { key: 'memoinfo', sortable: true, label: this.$t('ActList.Alert') },
                { key: 'patientName', sortable: true, label: this.$t('Shared.PatientName'), class: 'text-rigth' } ,
                { key: 'patientCode', sortable: true, label: this.$t('Shared.PatientCode'), class: 'text-rigth' },
                { key: 'patientDob', sortable: true, label: this.$t('Shared.Dob'), class: 'text-center hidden' },
                { key: 'isActiveTranslated', sortable: true, label: this.$t('Shared.Status'), class: 'text-center', formatter: null},
              ],
              pageOptions: [5, 10, 15 ],
              totalRows: 0,
              currentPage: 1,
              perPage: 10,
              selected: [],
              Header:{},
              refTable: 'selectableTable', 
              ShowMessageIsEmpty:true,
              FieldsDateArr:['dateFrom','dateTo'],    
          }
      },
      methods: {

          onShowing(e) {
            let contentElement = e.component.content();
            let titleElement = e.component._$title[0]
            contentElement.style.padding = '0px';
            titleElement.style.padding = '0px 20px'
          },

          onHiddenReport() {
            this.isReportVisible = false
          },

          ChangeDropDownPatients(values) {
            this.params.PatientCodeList = this.getItemsByComma(values, 'patientcode')
          },
          customLabelPatients ({ PatientName, patientcode }) {
            return `${PatientName} – ${patientcode}`
          },
          
          getItemsByComma(values, field) {
            let len = values.length;
            let valuesSeparated = [];
            if (len > 0){
              var i = 0;
              values.forEach(function(e) {   
                if(i < len-1){
                  valuesSeparated += e[field]+",";
                }else{
                  valuesSeparated += e[field];
                }
                i++;                    
              });
              return valuesSeparated;
            } else {
              return [];
            }
          },

          ChangeIsActive(item) {
            this.params.IsActive = item.value
          },
          ChangeIsActiveAdmission(item) {
            this.params.IsActiveAdmission = item.value
          },
          ChangeIsActiveAlert(item) {
            this.params.IsActiveAlert = item.value
          },
          getPatients() { 
            PatientService.getPatientList(this.parameter)
            .then((response) => {
              if(response.status == '200' && response.data && response.data.length > 0){
                this.PatientsList = response.data;
                this.PatientsList.forEach(function(element) {
                  element.PatientName = element.firstname + " " + element.lastname;   
                });
              }
            })
            .catch(error => {
              if (!error.response) {
              // network error
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
              } else {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
            });
          },

          onClickClose() {
            this.isParamVisible = false;
          },

          reportList() {
              this.checkExistFavorite('/app/reports/patients');
              this.$router.push({ name: "reportListPatient" }).catch(()=>{});
          },

          initializeParameters() {
             ['PatientCode','ByShowTo','NotShowMeMore'].forEach(
              key => this.parameter[key] = null
            );

            this.parameter.PatientCodeList = this.params.PatientCodeList && this.params.PatientCodeList !== ''
              ? this.params.PatientCodeList
              : null;
            this.parameter.DateFrom = this.dateFrom;
            this.parameter.DateTo = this.dateTo;
            this.parameter.Active = (this.params.IsActiveAlert === 'all') ? null : this.params.IsActiveAlert;
            this.parameter.PatientIsActive = (this.params.IsActive === 'all') ? null : this.params.IsActive;
            this.parameter.ActiveAdmission = (this.params.IsActiveAdmission === 'all') ? null : this.params.IsActiveAdmission;
            this.parameter.IsAlert = true;
          },

          initializePdfParameters() {
            this.reportParams = []
            this.reportParams.push({ paramName: 'pStartDate', paramValue: this.dateFrom})
            this.reportParams.push({ paramName: 'pEndDate', paramValue: this.dateTo})
            this.reportParams.push({ paramName: 'pPatientCodeList',paramValue: (this.params.PatientCodeList.length == 0) ? this.patientCode :this.params.PatientCodeList })
            this.reportParams.push({ paramName: 'pAlertStatus', paramValue: this.params.IsActiveAlert})
            this.reportParams.push({ paramName: 'pPatientStatus', paramValue: this.params.IsActive})
            this.reportParams.push({ paramName: 'pAdmissionStatus', paramValue: this.params.IsActiveAdmission})
            this.reportParams.push({ paramName: 'rSearchCriteria', paramValue: this.parameter.SearchCriteria})
          },
          onClickShowReport() {
            this.initializePdfParameters();
            this.isParamVisible = false
            this.isReportVisible = true
            this.$refs.reportPatientAlertFilters.buildDocument(this.reportParams)
          },
          LoadAlerts() {
              this.Loading = true;
              this.$emit('load', this.Loading);
              this.items = [];
              this.currentPage = 1;
              this.parameter.PageNumber = 1;
              this.totalRows = this.items.length;
              this.getListing();
          },

          getListing() {
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;
            this.initializeParameters();
           
            ActivitiesService
                .getAll(this.parameter, true)
                .then(response => {
                    if (response.status == "200" && response.data) {
                      this.items = response.data;
                      this.items.forEach(function(element) {
                        if (element.patientDob)	
                          element.patientDob = Utils.formatterDateToString(element.patientDob); 
                        if (element.datechanged)	
                          element.datechanged = Utils.formatterDateToString(element.datechanged); 
                      });

                      let headerString = response.headers["x-pagination"];
                      this.Header = JSON.parse(headerString);
                      this.totalRows = this.Header.TotalCount;
                      this.showEmptyRecords = response.data && response.data.length == 0 ? true : false
                      this.$emit('showEmptyRecords', this.showEmptyRecords);
                    }
                    this.$emit('load', false);
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                    this.$emit('load', false);
                });
          },
          pageChanged (page) {            
            this.currentPage = page;
            this.getListing();    
          },

          PerPageFunction(perpage){
            this.perPage = perpage;  
            this.currentPage = 1;
            this.getListing();
          },

          handleCSV(action) {
            this.initializeParameters();
            switch(action) {
              case 'export':
                this.$refs.csvExportHelper.exportCSV(this.parameter);
              break;
              case 'email':
                this.$refs.csvExportHelper.emailCSV(this.parameter);
              break;
              default:
                console.warn('unknow action:', action);
              break;
            }
          },

          handlePdf(action) {
            this.initializePdfParameters();
            switch(action) {
              case 'export':
                this.$refs.csvExportHelper.exportToPdf('PatientAlertFilters', true, false, this.reportParams);
              break;
              case 'email':
                this.$refs.csvExportHelper.emailPdf('PatientAlertFilters', true, false, this.reportParams);
              break;
              default:
                console.warn('unknow action:', action);
              break;
            }
          },
        },
      
      mounted () {
        this.getPatients();
        EventBus.$on("ShowWeel", function (isShow) { 
          isShow ? this.$emit('load', true) : this.$emit('load', false);     
        }.bind(this));
      },
  })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
